var _path, _g, _g2, _path2, _path3, _path4, _path5, _g3, _g4, _g5, _path6, _path7, _path8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinux(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 219,
    viewBox: "0 0 168 219",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M115.572 212.765C87.0894 212.765 63.9998 209.86 63.9998 206.277C63.9998 202.694 87.0894 199.79 115.572 199.79C144.054 199.79 167.144 202.694 167.144 206.277C167.144 209.86 144.054 212.765 115.572 212.765Z",
    fill: "#14130D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_802:732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.87793 144.396V145.322C8.87793 148.621 9.53099 151.888 10.7995 154.933L27.8349 195.837C31.7157 205.155 40.8194 211.225 50.9133 211.225H103.478C112.431 211.225 120.7 206.437 125.158 198.673L144.761 164.534C145.488 163.267 146.103 161.939 146.598 160.565L148.81 154.43C149.791 151.71 150.293 148.841 150.293 145.95V134.443C150.293 132.507 150.068 130.578 149.623 128.695L146.719 116.404C146.145 113.975 145.211 111.645 143.947 109.493L138.244 99.7811L128.097 84.8787L117.951 72.568L115.283 68.2067C112.881 64.2794 111.61 59.765 111.61 55.1612V45.355V40.0274C111.61 37.1221 111.103 34.239 110.113 31.5076L106.855 22.5188C105.806 19.6258 104.232 16.9513 102.213 14.6297L98.4651 10.3222C96.2589 7.78633 93.564 5.72134 90.5415 4.25077L86.9834 2.5196C83.5756 0.861578 79.8355 0 76.0458 0H71.8883C68.3918 0 64.9343 0.733428 61.7389 2.15291L56.5826 4.44352C53.5611 5.78577 50.8547 7.74688 48.6383 10.2002C45.8553 13.2806 43.9326 17.0395 43.0635 21.0989L40.5051 33.0485C40.1368 34.7688 39.9511 36.5231 39.9511 38.2823V50.8651C39.9511 52.8006 40.1759 54.7295 40.6208 56.613L42.2364 63.4516C43.6251 69.3297 42.8388 75.5118 40.0228 80.8551L39.9511 80.9911L35.7844 89.0326C34.7619 91.006 33.4808 92.8342 31.9749 94.469L26.8813 99.9986C25.0378 102 23.5333 104.289 22.4273 106.775L14.5852 124.402L10.4087 135.782C9.39613 138.541 8.87793 141.457 8.87793 144.396Z",
    fill: "#263238"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_802:732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.179 80.2737L61.4957 79.1988C60.6923 78.6858 60.1176 77.8828 59.8911 76.957C59.028 73.4295 54.1319 73.1212 52.8331 76.5125L51.6778 79.5291C51.4717 80.0673 51.366 80.6388 51.366 81.2151V86.7275C51.366 88.9093 50.7712 91.0498 49.6455 92.9188L46.7494 97.7273C46.4454 98.2319 46.1047 98.7135 45.73 99.1681L36.8329 109.963C36.3762 110.517 35.9702 111.111 35.6197 111.738L31.9359 118.325C31.3639 119.347 30.9448 120.448 30.692 121.592L27.3093 136.898C26.8667 138.901 26.9448 140.984 27.5363 142.948L28.0333 144.598C28.7722 147.052 30.2772 149.205 32.328 150.741L38.6831 155.503L55.9074 171.966C57.4995 173.488 58.642 175.419 59.21 177.546L60.0081 180.536C60.1647 181.123 60.244 181.728 60.244 182.335V183.537C60.244 185.419 59.1891 187.143 57.5129 187.999L56.8024 188.362C56.5637 188.484 56.2994 188.547 56.0312 188.547C54.5298 188.547 53.7695 190.355 54.8197 191.428L56.0726 192.708C56.3142 192.955 56.6054 193.148 56.9269 193.275L70.0339 198.425C71.9313 199.171 73.9874 199.421 76.0081 199.152L85.7157 197.858C86.9067 197.699 88.0671 197.362 89.1581 196.859L105.167 189.472C106.492 188.861 107.694 188.013 108.715 186.97L117.03 178.474C118.862 176.602 120.031 174.182 120.36 171.584L122.39 155.503V142.544L120.059 123.486C119.923 122.374 119.632 121.288 119.195 120.257L111.61 102.373L103.366 84.8788L95.3088 70.1782C95.0912 69.7813 94.4879 69.9358 94.4879 70.3884C94.4879 70.5357 94.4138 70.673 94.2907 70.7539L85.6099 76.4557L77.2943 80.454C75.6718 81.2341 73.8946 81.6391 72.0944 81.6391H67.8542C66.1975 81.6391 64.5753 81.1654 63.179 80.2737Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.293 49.2427V49.9619C72.293 52.8236 73.4139 55.5714 75.4155 57.6165L76.0929 58.3087C77.7183 59.9694 79.9441 60.9054 82.2679 60.9054C84.7916 60.9054 87.1891 59.8021 88.8306 57.8853L89.3432 57.2867C90.2279 56.2537 90.9003 55.0565 91.3222 53.7635L92.0104 51.6539C92.8035 49.2229 92.962 46.6295 92.4707 44.1201L92.3729 43.6201C92.0937 42.1941 91.5901 40.8214 90.8808 39.5531L90.4914 38.8568C89.7821 37.5886 88.8073 36.4885 87.6335 35.6319L87.5371 35.5616C85.8728 34.3469 83.8656 33.6924 81.8052 33.6924H81.5987C79.6724 33.6924 77.796 34.3043 76.2401 35.4398C74.9024 36.4161 73.8569 37.7392 73.2163 39.2663L73.091 39.5649C72.5643 40.8207 72.293 42.1689 72.293 43.5308V49.2427Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3657 50.5387V51.9658C77.3657 53.2853 77.7769 54.572 78.5421 55.647L79.4102 56.8665C80.0565 57.7746 81.1023 58.3139 82.2169 58.3139C83.4067 58.3139 84.5123 57.7 85.1413 56.6901L85.7927 55.6442C86.1169 55.1237 86.3544 54.554 86.496 53.9574L86.9015 52.2481C87.305 50.5477 87.3856 48.7867 87.1393 47.0565L87.0717 46.5813C86.9557 45.767 86.7404 44.9701 86.4306 44.2082L86.0424 43.2539C85.7948 42.6452 85.4284 42.0919 84.9645 41.6264L84.6002 41.2608C83.9055 40.5637 82.9618 40.1719 81.9777 40.1719C80.9935 40.1719 80.0499 40.5637 79.3552 41.2608L79.0944 41.5226C78.5649 42.0539 78.1737 42.7067 77.9548 43.4242L77.7115 44.2219C77.4822 44.9734 77.3657 45.7546 77.3657 46.5403V50.5387Z",
    fill: "#263238"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6831 51.6494V52.2768C64.6831 54.8802 63.6601 57.3794 61.8347 59.2356L61.2339 59.8465C59.7525 61.3529 57.7282 62.2014 55.6154 62.2014C53.3202 62.2014 51.1392 61.2008 49.6422 59.461L49.1876 58.9328C48.3803 57.9946 47.7662 56.9061 47.3807 55.73L46.8121 53.9956C46.0559 51.6885 45.9048 49.2259 46.3733 46.8437L46.4276 46.5677C46.682 45.274 47.1409 44.029 47.7868 42.8796L48.1345 42.2607C48.7823 41.108 49.6716 40.1089 50.7415 39.3318L50.821 39.274C52.3368 38.173 54.1622 37.5801 56.0357 37.5801H56.234C57.9786 37.5801 59.6784 38.1322 61.0899 39.1575C62.3091 40.0431 63.263 41.2452 63.8482 42.6338L63.9562 42.89C64.436 44.0283 64.6831 45.2511 64.6831 46.4864V51.6494Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8784 52.2045V53.106C60.8784 54.2805 60.4814 55.4205 59.7518 56.3409L59.151 57.0988C58.5427 57.8661 57.6172 58.3135 56.6381 58.3135C55.5868 58.3135 54.6023 57.7982 54.0032 56.9344L53.55 56.2811C53.2367 55.8294 53.0047 55.3265 52.8642 54.795L52.5357 53.5519C52.1827 52.2158 52.1121 50.8207 52.3285 49.4558L52.3783 49.142C52.4846 48.4716 52.6804 47.8184 52.9605 47.2L53.246 46.5698C53.4891 46.0331 53.8405 45.5524 54.2782 45.158L54.4985 44.9595C55.1418 44.3799 55.977 44.0591 56.8429 44.0591C57.7089 44.0591 58.5441 44.3799 59.1874 44.9595L59.31 45.0701C59.8092 45.5199 60.1848 46.0901 60.401 46.7263L60.5653 47.21C60.7726 47.8204 60.8784 48.4607 60.8784 49.1053V52.2045Z",
    fill: "#263238"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_802:732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.1253 205.654L64.4363 207.891C64.5996 209.066 64.5703 210.26 64.3494 211.425L64.1194 212.638C63.7462 214.607 62.631 216.358 61.0042 217.528C59.6743 218.485 58.0773 219 56.4389 219H54.6847C53.7208 219 52.7599 218.895 51.8188 218.687L40.8523 216.259C39.1893 215.891 37.5666 215.36 36.0074 214.675L24.6139 209.665L20.7757 208.532C18.3859 207.827 15.9072 207.469 13.4155 207.469H10.9643C9.76645 207.469 8.57455 207.301 7.42344 206.97L6.03231 206.569C4.34369 206.083 2.85175 205.076 1.76945 203.692L1.35283 203.159C0.476228 202.038 0 200.656 0 199.233C0 197.809 0.476229 196.427 1.35283 195.306L1.71725 194.84C2.82998 193.417 3.43449 191.662 3.43449 189.855V187.702C3.43449 185.542 2.87332 183.42 1.80599 181.543L0.866694 179.891C0.29866 178.892 0 177.763 0 176.614V175.968C0 174.361 0.730917 172.841 1.98635 171.837C2.92381 171.088 4.08829 170.68 5.28846 170.68H8.10041C9.93104 170.68 11.742 170.302 13.42 169.57L13.4831 169.543C15.8913 168.493 17.9451 166.77 19.3974 164.58L20.3945 163.077C20.9171 162.29 21.4955 161.541 22.1253 160.836L23.8475 158.908C24.3556 158.34 24.9446 157.849 25.5956 157.451C28.7027 155.555 32.7094 156.065 35.2413 158.681L37.5765 161.093C38.0923 161.626 38.5574 162.206 38.966 162.825L49.2277 178.367L58.9588 192.643L61.5666 197.647C62.8713 200.15 63.7367 202.858 64.1253 205.654Z",
    fill: "#FFC107"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_802:732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.6582 198.677V207.858V211.732C97.6582 214.182 98.8923 216.467 100.941 217.81C102.125 218.586 103.51 219 104.926 219H108.997C111.976 219 114.922 218.363 117.635 217.131L118.166 216.89C119.969 216.072 121.662 215.029 123.205 213.788L127.112 210.644L133.937 205.273C135.05 204.398 136.231 203.615 137.471 202.933L149.769 196.159L152.631 194.149C153.358 193.638 153.965 192.976 154.411 192.208L154.773 191.585C155.543 190.26 155.625 188.645 154.994 187.249L154.869 186.973C154.178 185.443 152.655 184.46 150.977 184.46C150.187 184.46 149.413 184.241 148.74 183.828L145.85 182.051C145.442 181.8 145.054 181.52 144.688 181.211L143.402 180.127C142.052 178.989 141.273 177.313 141.273 175.546V172.421C141.273 170.827 140.795 169.27 139.901 167.951L139.643 167.57C139.223 166.952 138.685 166.422 138.06 166.012C136.522 165.004 134.591 164.805 132.881 165.478L132.418 165.66C130.83 166.284 129.545 167.497 128.829 169.046L128.047 170.739C127.434 172.063 126.483 173.203 125.29 174.041C123.895 175.021 122.233 175.546 120.529 175.546H119.316C118.123 175.546 116.959 175.178 115.983 174.493C114.438 173.407 113.518 171.637 113.518 169.748V169.369C113.518 169.031 113.492 168.694 113.44 168.36L112.681 163.512C112.491 162.295 111.847 161.196 110.88 160.434C110.02 159.758 108.959 159.391 107.865 159.391H107.728C106.702 159.391 105.697 159.691 104.838 160.254L104.658 160.372C103.433 161.175 102.544 162.4 102.161 163.814L101.079 167.806C100.688 169.246 100.49 170.732 100.49 172.224V179.157C100.49 180.831 100.328 182.502 100.007 184.146L98.1414 193.688C97.82 195.332 97.6582 197.002 97.6582 198.677Z",
    fill: "#FFC107"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_di_802:732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.8168 61.1943L49.7938 65.3001C49.1604 65.8178 48.6637 66.483 48.3473 67.2373L48.0218 68.0134C47.3424 69.633 47.5627 71.4903 48.6019 72.9061L50.3357 75.268C50.5985 75.626 50.9078 75.9475 51.2555 76.2238L56.439 80.3429L62.0867 84.5397C62.949 85.1804 63.9946 85.5264 65.0689 85.5264H73.3689C74.3225 85.5264 75.2562 85.2537 76.0599 84.7404L79.9024 82.2867L88.1463 77.1033L92.8474 74.0467C94.266 73.1243 95.1219 71.5469 95.1219 69.8548V68.7439C95.1219 67.8537 94.8842 66.9796 94.4334 66.212L94.0096 65.4903C93.4951 64.6141 92.7257 63.9154 91.8041 63.4874L86.2438 60.9051L76.4373 56.5215C76.2111 56.4203 75.9776 56.3362 75.739 56.2697L70.6118 54.841C69.6412 54.5705 68.6115 54.5996 67.6577 54.9244L63.8291 56.2284C63.5533 56.3223 63.2862 56.4402 63.0309 56.5806L55.571 60.6848C55.3047 60.8313 55.0522 61.0019 54.8168 61.1943Z",
    fill: "#FFC107"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0005 69.9765L54.5441 72.5115C55.8717 73.8345 57.4248 74.9099 59.1304 75.6869V75.6869C61.1797 76.6206 63.4055 77.1037 65.6575 77.1037H66.3622C67.7815 77.1037 69.1962 76.9446 70.58 76.6294L71.0136 76.5306C73.1174 76.0514 75.1393 75.2653 77.0143 74.1975L79.8752 72.5682L84.4262 69.9765L87.8394 67.3848",
    stroke: "#263238",
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.415 62.849L66.5858 60.2573",
    stroke: "#263238"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9268 60.2573L76.0975 62.2011",
    stroke: "#263238"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_802:732",
    x: 8.87793,
    y: 0,
    width: 141.415,
    height: 215.225,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.37 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_802:732"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_802:732",
    x: 27.0264,
    y: 69.9502,
    width: 95.3643,
    height: 130.307,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.48 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_802:732"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_802:732",
    x: 0,
    y: 156.312,
    width: 64.54,
    height: 64.6885,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_802:732"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_802:732",
    x: 97.6582,
    y: 159.391,
    width: 57.7568,
    height: 61.6094,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_802:732"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_di_802:732",
    x: 42.6323,
    y: 51.6572,
    width: 57.4897,
    height: 40.8691,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_802:732"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_802:732",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_802:732"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinux);
export default __webpack_public_path__ + "static/media/linux.a9acd008.svg";
export { ForwardRef as ReactComponent };